import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GalleryService } from '../../providers/gallery.service';
import { LoggerService } from '../../providers/logger.service';
import * as $ from 'jquery'
import {
  wrapperGetLogoUrlInApp
} from '../../javascript.js';
import { DialogService } from '../../dialogs/dialog.service';

@Component({
  selector: 'app-folder',
  templateUrl: './folder.component.html',
  styleUrls: ['./folder.component.css']
})
export class FolderComponent implements OnInit {

  document:any //$routeParams['document'];
  files = [];

  token:any //$routeParams['token'];
  grayscale: any //$routeParams['grayscale'];
  searchParams = [];
  searchParam: any;

  moveFrom: any = undefined;
  pages: any;

  constructor(private translateService: TranslateService,
    private route: ActivatedRoute,
    private dialogs: DialogService,
    private gallery: GalleryService,
    private logger: LoggerService) { }

  ngOnInit(): void {
    this.document = this.route.snapshot.params['document'];
    this.token = this.route.snapshot.params['token'];
    this.grayscale = this.route.snapshot.params['grayscale'];

    if (this.token !== undefined) this.searchParams.push("token=" + this.token);
    if (this.grayscale !== undefined) this.searchParams.push("grayscale=" + this.grayscale);
    this.searchParam = this.searchParams.length === 0 ? "" : this.searchParams.join("&");

    this.setLogoUrl();
  }

  getPages() {
    this.gallery.list(this.document).then(
      data => {
        if (data === undefined || data['status'] === 1)
          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('SessionExpired')/*,
            () { $location.path("/"); }*/
          );
        else if (data['status'] === 0) {
          this.pages = data['pages'];
        }
        else this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorLoadingPages')/*,
          () { $location.path("/"); }*/
        );
      }
    );
  }

  /**
   * Drag start callback
   * @param {any} from - id of the 'from' page.
   */
  movePageFrom(from) {
    this.moveFrom = from;
  }

  /**
   * Drop callback 
   * @param {any} to - id of the 'to' page.
   */
  movePageTo(to) {
    this.movePage(this.moveFrom, to);
    this.moveFrom = undefined;
  }

  /**
   * Moves the page at position 'from' to position 'to'.
   * @param {any} from
   * @param {any} to
   */
  movePage(from, to) {

    this.gallery.movePage(this.document, from, to).then(
      data => {
        if (data === undefined || data['status'] === 1)
          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('SessionExpired')/*,
            () { $location.path("/"); }*/
          );
        else if (data['status'] === 0) this.getPages();
        else this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorMovingPages'));
      }
    );

  }

  deletePageDialog(f, idx) {

    if (this.pages.length <= 1) {

      this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorDeleteLastPage'));
      return;

    }

    this.dialogs.openDeleteDialog(this.translateService.instant('page') + ' ' + (idx + 1), f, id => { this.deletePage(id); });
  }

  deletePage(f) {
    this.gallery.deletePage(this.document, f).then(
      data => {
        if (data === undefined || data['status'] === 1)
          this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('SessionExpired')/*,
            () { $location.path("/"); }*/
          );
        else if (data['status'] === 0) this.getPages();
        else this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('ErrorDeletePage'));
      }
    );
  }

  setLogoUrl() {
    try {
      $("#van-logo").attr("href", wrapperGetLogoUrlInApp());
    } catch (e) { }
  }

}
